import React, { useCallback, useEffect, useState } from 'react'
import authAxios from '../../../../config/authAxios'
import SpinnerLoading from '../../../components/Spinners/SpinnerLoading'

const label = value => String(value || '').replace(/_/g,' ')
const shortDate = value => value ? String(value).slice(0,19).replace('T',' ') : ''

const ACCIONES = [
  'corte_creado','recomendacion_creada','recomendacion_superada','recomendacion_aprobada','recomendacion_rechazada',
  'ejecucion_meta','ejecucion_manual','verificacion_automatica','prueba_audiencia_registrada','resultado_audiencia_registrado',
  'cambio_audiencia_detectado','alerta_emitida','umbral_propuesto','umbral_aprobado','umbral_rechazado',
  'congelar_umbral_oficial','kr_guardado','pieza_editada','bitacora_estado_cambiado','bitacora_resultado_guardado',
  'bitacora_hito_borrado','bitacora_piezas_vinculadas','bitacora_legacy_borrada','bandera_nivel2_creada','bandera_nivel2_acusada',
]
const NIVELES = ['nivel1','nivel2','usuario','sistema']

/**
 * Historia 9: lectura del log inmutable (marketing_auditoria_log). SOLO
 * LECTURA — no hay ningun control de edicion/borrado aqui ni en el backend.
 * Compartido entre la pagina de Operaciones y la pestaña Historial del panel
 * de Marketing.
 */
const RegistroAuditoria = ({ campaignId }) => {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [accion, setAccion] = useState('')
  const [nivel, setNivel] = useState('')
  const [desde, setDesde] = useState('')
  const [hasta, setHasta] = useState('')
  const [selected, setSelected] = useState(null)

  const load = useCallback(() => {
    if (!campaignId) return
    setLoading(true); setError('')
    const params = new URLSearchParams({ id_camp: campaignId })
    if (accion) params.set('accion', accion)
    if (nivel) params.set('nivel', nivel)
    if (desde) params.set('desde', desde)
    if (hasta) params.set('hasta', hasta)
    authAxios.get(`/admin/agente-marketing/auditoria?${params.toString()}`)
      .then(r => setRows(r.data?.data || []))
      .catch(e => setError(e.response?.data?.msg || 'No se pudo cargar el registro de auditoría.'))
      .finally(() => setLoading(false))
  }, [campaignId, accion, nivel, desde, hasta])

  useEffect(() => { load() }, [load])

  return <div>
    <div className="row mb-3">
      <div className="col-md-3 mb-2"><select className="form-control" value={accion} onChange={e => setAccion(e.target.value)}>
        <option value="">Todas las acciones</option>{ACCIONES.map(a => <option key={a} value={a}>{label(a)}</option>)}
      </select></div>
      <div className="col-md-3 mb-2"><select className="form-control" value={nivel} onChange={e => setNivel(e.target.value)}>
        <option value="">Todos los niveles</option>{NIVELES.map(n => <option key={n} value={n}>{label(n)}</option>)}
      </select></div>
      <div className="col-md-3 mb-2"><input type="date" className="form-control" value={desde} onChange={e => setDesde(e.target.value)} placeholder="Desde" /></div>
      <div className="col-md-3 mb-2"><input type="date" className="form-control" value={hasta} onChange={e => setHasta(e.target.value)} placeholder="Hasta" /></div>
    </div>
    {error && <div className="alert alert-danger">{error}</div>}
    {loading ? <SpinnerLoading /> : (rows.length === 0 ? <p className="am-empty-tab">Sin registros de auditoría para estos filtros.</p> : <div className="am-table-wrap">
      <table className="table am-table"><thead><tr><th>Fecha</th><th>Acción</th><th>Entidad</th><th>Actor</th><th>Resultado</th><th></th></tr></thead>
      <tbody>{rows.map(r => <tr key={r.id_log}>
        <td>{shortDate(r.ocurrido_en)}</td>
        <td><span className={`am-badge am-badge-${r.nivel === 'sistema' ? 'sin_datos' : 'verde'}`}>{label(r.nivel)}</span> {label(r.accion)}</td>
        <td>{r.entidad}{r.entidad_id ? ` #${r.entidad_id}` : ''}</td>
        <td>{r.actor_id ? `#${r.actor_id} · rol ${r.actor_rol}` : '—'}</td>
        <td>{r.resultado || '—'}</td>
        <td><button className="btn btn-sm btn-outline-secondary" title="Ver detalle" onClick={() => setSelected(r)}>👁</button></td>
      </tr>)}</tbody></table>
    </div>)}
    {selected && <div className="am-modal-backdrop" onClick={() => setSelected(null)}><div className="am-modal-card" onClick={e => e.stopPropagation()}>
      <div className="d-flex justify-content-between"><h5>Auditoría · {label(selected.accion)}</h5><button className="close" onClick={() => setSelected(null)}>&times;</button></div>
      <p className="text-muted mb-2">{shortDate(selected.ocurrido_en)} · {selected.entidad}{selected.entidad_id ? ` #${selected.entidad_id}` : ''} · nivel {label(selected.nivel)}</p>
      <div className="am-detail">
        <strong>Dato de origen</strong>
        <pre style={{whiteSpace:'pre-wrap',wordBreak:'break-word',fontSize:'.78rem',margin:'6px 0 14px'}}>{selected.dato_origen ? JSON.stringify(selected.dato_origen,null,2) : '—'}</pre>
        <strong>Detalle (antes / después cuando aplica)</strong>
        <pre style={{whiteSpace:'pre-wrap',wordBreak:'break-word',fontSize:'.78rem',margin:'6px 0 0'}}>{selected.detalle ? JSON.stringify(selected.detalle,null,2) : '—'}</pre>
      </div>
    </div></div>}
  </div>
}

export default RegistroAuditoria
